'use strict';

var _ = require('lodash');
var NewRoleController = function NewRoleController($scope, dataRetrieverService, userManagementCommonCustomRenderers, newRoleService, userManagementConstants, userManagementSelectedRole) {
  $scope.components = null;
  $scope.mode = 'user-management-roles-mode';
  $scope.gridId = 'user-management-roles';
  $scope.roleExists = false;
  $scope.ROLE_NAME_PATTERN = /^[A-Za-z0-9-_]{2,50}$/;
  $scope.customRenderers = userManagementCommonCustomRenderers;
  $scope.usersAssigned = userManagementSelectedRole.refreshUsersAssigned();
  dataRetrieverService.getDataRetriever('USER_MANAGEMENT_SCREEN', $scope.mode).setCustomSearchCriteriaRules([]);
  function reset() {
    $scope.visible = false;
    $scope.isEdit = false;
    $scope.editRole = null;
  }
  function save(components, roleName, onlySave) {
    return newRoleService.save(components, roleName, onlySave).then(function () {
      $scope.roleExists = true;
      $scope.isEdit = true;
      $scope.editRole = roleName;
    });
  }
  $scope.$watch('visible', function (isVisible) {
    if (isVisible) {
      $scope.open();
    }
  });
  $scope.open = function () {
    $scope.$broadcast('grid:loadData:' + $scope.gridId);
  };
  $scope.saveRole = function () {
    var components = _.chain($scope.components).clone(true).value(true);
    if (!$scope.isEdit) {
      newRoleService.isExistsRole($scope.roleName).then(function () {
        save(components, $scope.roleName, true);
      });
    } else {
      save(components, $scope.editRole, false);
    }
  };
  function transformRoleToComponents(role) {
    var roleComponents = [];
    if (role.attributes.role !== $scope.editRole) {
      return roleComponents;
    }
    _.transform(role.properties.privileges, function (result, privilege) {
      result[privilege.component] = privilege;
    }, roleComponents);
    return roleComponents;
  }
  function aggregatePermissionsToRole(roleComponents, categoryComponents) {
    _.forEach(categoryComponents, function (item) {
      var role = roleComponents[item.component];
      if (role) {
        if (role.privilege === 'WRITE') {
          item.isEditable = true;
          item.isViewable = true;
        } else if (role.privilege === 'READ') {
          item.isEditable = false;
          item.isViewable = true;
        }
      }
    });
    return categoryComponents;
  }
  function disableDependentPermissions(rowInfo, loadedData, gridId) {
    var parentPermission = loadedData[rowInfo.rowindex];
    var parent = null;
    function getSetCellValueParams(item, value, property) {
      return {
        rowId: loadedData.indexOf(item),
        columnName: property,
        newValue: value,
        oldValue: item[property],
        gridId: gridId,
        refreshOnly: true
      };
    }
    _.forEach(loadedData, function (loadedItem) {
      parent = _.find(loadedItem.parents, ['component', parentPermission.component]);
      if (parent) {
        if (rowInfo.datafield === 'isViewable' && parent.privilege === 'READ') {
          //disable child's READ permission
          $scope.$broadcast('grid:setCellValue', getSetCellValueParams(loadedItem, false, 'isViewable'));
        }
        if (rowInfo.datafield === 'isEditable' && parent.privilege === 'WRITE') {
          //disable child's WRITE permission, this should trigger an auto disable of the READ as well
          $scope.$broadcast('grid:setCellValue', getSetCellValueParams(loadedItem, false, 'isEditable'));
        }
      }
    });
  }
  $scope.onBeforeShowData = function (categoryComponents) {
    $scope.components = categoryComponents;
    if ($scope.isEdit) {
      return newRoleService.getRole($scope.editRole).then(function (role) {
        var transformedRole = transformRoleToComponents(role);
        return aggregatePermissionsToRole(transformedRole, categoryComponents);
      });
    }
    return categoryComponents;
  };
  $scope.canSave = function () {
    return $scope.roleName || $scope.isEdit && $scope.editRole;
  };
  $scope.canAssign = function () {
    return $scope.roleExists || $scope.isEdit;
  };
  $scope.returnRoleName = function () {
    return $scope.roleName || $scope.isEdit && $scope.editRole;
  };
  $scope.cancel = function () {
    reset();
    $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
  };
  $scope.$on('grid:cellValueChanged', function (ev, rowInfo, gridId) {
    if (gridId !== $scope.gridId) {
      return false;
    }
    function getSetCellParams(property) {
      return {
        rowId: rowInfo.rowindex,
        columnName: property,
        newValue: rowInfo.newvalue,
        oldValue: rowInfo.oldvalue,
        gridId: gridId,
        refreshOnly: true
      };
    }
    var loadedData = _.get(rowInfo, 'owner.source.loadedData', []);
    var row = loadedData[rowInfo.rowindex];
    if (rowInfo.datafield === 'isEditable') {
      if (row.viewEnabled) {
        if (rowInfo.newvalue === true || row.component === 'user-management') {
          $scope.$broadcast('grid:setCellValue', getSetCellParams('isViewable'));
        }
      }
    } else if (rowInfo.datafield === 'isViewable') {
      if (row.editEnabled && rowInfo.newvalue === false) {
        $scope.$broadcast('grid:setCellValue', getSetCellParams('isEditable'));
      }
    }
    if (rowInfo.newvalue === false) {
      disableDependentPermissions(rowInfo, loadedData, gridId);
    }
  });
};
NewRoleController.$inject = ['$scope', 'DataRetrieverService', 'UserManagementCommonCustomRenderers', 'NewRoleService', 'UserManagementConstants', 'UserManagementSelectedRoleService'];
module.exports = NewRoleController;